// Admin translations - German
export const de = {
  // Auth
  "admin_panel": "Admin-Panel",
  "setup_admin": "Admin-Konto erstellen",
  "admin_login": "Admin-Anmeldung",
  "email": "E-Mail",
  "password": "Passwort",
  "confirm_password": "Passwort bestätigen",
  "login": "Anmelden",
  "logout": "Abmelden",
  "setup": "Konto erstellen",
  "office_email_only": "Nur office@neuro-mesh.io kann Admin sein",
  "password_requirements": "Passwort muss mindestens 14 Zeichen mit Groß-, Kleinbuchstaben, Zahl und Sonderzeichen enthalten",
  
  // Navigation
  "dashboard": "Dashboard",
  "users": "Benutzer",
  "analytics": "Analytik",
  "export": "Export-Center",
  "system_health": "Systemzustand",
  
  // Dashboard
  "overview": "Übersicht",
  "total_users": "Gesamtbenutzer",
  "users_7d": "Benutzer (7T)",
  "users_today": "Benutzer Heute",
  "total_sessions": "Gesamtsitzungen",
  "sessions_7d": "Sitzungen (7T)",
  "cerebro_events": "Cerebro-Ereignisse",
  "robomesh_events": "RoboMesh-Ereignisse",
  "visits_over_time": "Besuche im Zeitverlauf",
  "mode_split": "Modusverteilung",
  
  // Users
  "user_list": "Benutzerliste",
  "search_users": "Benutzer suchen...",
  "name": "Name",
  "provider": "Anbieter",
  "created_at": "Erstellt",
  "last_active": "Zuletzt aktiv",
  "sessions": "Sitzungen",
  "actions": "Aktionen",
  "view_details": "Details anzeigen",
  
  // Analytics
  "event_types": "Ereignistypen",
  "mode_usage": "Modusnutzung",
  "last_30_days": "Letzte 30 Tage",
  
  // Export
  "export_data": "Daten exportieren",
  "export_users": "Benutzer exportieren",
  "export_sessions": "Sitzungen exportieren",
  "format": "Format",
  "csv": "CSV",
  "json": "JSON",
  "download": "Herunterladen",
  
  // System Health
  "recent_events": "Letzte Ereignisse",
  "recent_audit_logs": "Letzte Audit-Protokolle",
  "database_stats": "Datenbankstatistiken",
  "status": "Status",
  "healthy": "Gesund",
  
  // Common
  "loading": "Wird geladen...",
  "error": "Fehler",
  "success": "Erfolg",
  "page": "Seite",
  "of": "von",
  "no_data": "Keine Daten verfügbar",
  "language": "Sprache",
  "english": "English",
  "chinese": "中文",
  "german": "Deutsch"
};
